import { Shield } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
// The manifest, never `../index.js`: the plugin definition imports
// `node:path` and the server routes, which must not reach the browser
// bundle.
import { chiefWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  chiefWeb,
  {
    ChiefPage: () => import('./ChiefPage'),
    ChiefHost: () => import('./ChiefHost'),
    ChiefNavButton: () => import('./ChiefNavButton'),
  },
  {
    icons: { Shield },
  },
);
